import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';

const AmountEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);


    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });


    useEffect(() => {
        if (!editing) {

            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };

    const onChange = (e) => {
        console.log(e.target.value)
        setSelectedVal(e.target.value)
        props.node.setDataValue("amount", e.target.value);

    }

    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span className="selectCell">
            <input className="form-control"
                value={selectedVal}
                onChange={onChange}
                ref={refContainer}
            >
            </input>
        </span>
    </div>
    );
});

export default AmountEditor
